import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { LoyaltyProgramFacade } from '@features/loyalty-program/facades/loyalty-program.facade';
import { LoyaltyCurrencyFacade } from '@rd/core//facades/loyalty-currency-facade/loyalty-currency.facade';
import { AnalyticsService } from '@rd/core/services/analytics/analytics.service';
import { PageTitleService } from '@rd/core/services/page-title/page-title.service';
import { LoyaltyCurrency, LoyaltyProgram } from '@rd/types';
import { LoyaltyProgramCategory } from '@rd/types/loyalty-program.type';
import { isNotNull } from '@rd/utils/isNotNull';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import { TransferConnectV2SettingService } from '../../services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';

@Component({
  selector: 'rd-tcv2-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TcV2ProgramsComponent implements OnInit, OnDestroy {
  @HostBinding('class.rd-tcv2-programs') componentClass = true;

  loyaltyProgramCategory: LoyaltyProgramCategory | 'all' = 'all';
  loyaltyProgramIndexLoading$: Observable<boolean> =
    this.loyaltyProgramFacade.loadLoyaltyProgramsLoading$;
  loyaltyProgramIndexError$: Observable<boolean> =
    this.loyaltyProgramFacade.loadLoyaltyProgramsError$;
  loyaltyProgramLoyaltyPrograms$: Observable<LoyaltyProgram[]> =
    this.loyaltyProgramFacade.filteredPointsTransferLoyaltyPrograms$;
  loyaltyCurrencySelected$: Observable<LoyaltyCurrency> =
    this.loyaltyCurrencyFacade.getLoyaltyCurrencySelected$.pipe(
      filter(isNotNull),
    );

  vm$ = combineLatest([
    this.loyaltyProgramIndexLoading$,
    this.loyaltyProgramIndexError$,
    this.loyaltyProgramLoyaltyPrograms$,
    this.loyaltyCurrencySelected$,
  ]).pipe(
    map(([loading, error, loyaltyPrograms, selectedLoyaltyCurrency]) => ({
      loading,
      error,
      loyaltyPrograms,
      selectedLoyaltyCurrency,
    })),
  );

  loyaltyProgramCategoryOptions: (LoyaltyProgramCategory | 'all')[] = [
    'all',
    LoyaltyProgramCategory.Airline,
    LoyaltyProgramCategory.Hotel,
  ];
  keyword = '';
  destroy$ = new Subject();

  constructor(
    protected transferConnectV2SettingService: TransferConnectV2SettingService,
    protected analyticsService: AnalyticsService,
    protected pageTitleService: PageTitleService,
    protected loyaltyProgramFacade: LoyaltyProgramFacade,
    protected loyaltyCurrencyFacade: LoyaltyCurrencyFacade,
  ) {}

  ngOnInit(): void {
    this.pageTitleService.setPageTitle('transfer-connect-listing');
    this.analyticsService.track({
      // @ts-ignore
      routeName: this.analyticsService.sitemap.transferConnect.listing,
    });

    this.loyaltyProgramLoyaltyPrograms$
      .pipe(
        filter((lps) => lps.length > 0),
        first(),
      )
      .subscribe(() => {
        this.analyticsService.track({
          routeName:
            // @ts-ignore
            this.analyticsService.sitemap.transferConnect.listingFullData,
        });
      });
  }

  ngOnDestroy(): void {
    this.loyaltyProgramFacade.changeLoyaltyProgramsFilterKeyword('');
    this.loyaltyProgramFacade.changeLoyaltyProgramsFilterCategory('all');
  }

  categoryChange(category: LoyaltyProgramCategory | 'all'): void {
    this.loyaltyProgramCategory = category;
    this.loyaltyProgramFacade.changeLoyaltyProgramsFilterCategory(category);
  }

  keywordChange(keyword: string): void {
    this.keyword = keyword;
    this.loyaltyProgramFacade.changeLoyaltyProgramsFilterKeyword(keyword);
  }
}
